import React, { useState, useEffect, useRef } from "react";
import "./Myspace.scss";
import { TfiViewListAlt, TfiLayoutGrid2 } from "react-icons/tfi";
import { MdOutlineContentCopy } from "react-icons/md";
import { useOutletContext } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import Searchbar from "../../../components/searchBar/Searchbar";
import Pagination from "../../../components/Pagination/Pagination";
import { getFileIcon } from "../../../utils/services/fileTypeIcons";
import {
  bytesToString,
  clipText,
  copyToClipboard,
  getGridItemsPerPage,
  getItemsPerPage,
} from "../../../utils/services/other";
import Skeleton from "react-loading-skeleton";
import History from "../../../utils/services/GlobalNavigation/navigationHistory";
import { Popover } from "react-tiny-popover";
import { getActivePlanList, getUploadedFiles } from "../../../utils/services/lighthouse";
import { bindActionCreators } from "redux";
import { otherDataAC } from "../../../store/action-creators";
import { createReferedByEntry, setAllTransactions } from "../../../utils/services/user";

function Myspace() {
  const [infoBarData, setInfoBarData] = useOutletContext<any>();
  const [currentItems, setCurrentItems] = useState<any[]>([]);
  const [filteredItems, setFilteredItems] = useState<any[]>([]);
  const [orignalItems, setOrignalItems] = useState<any[]>([]);
  const [itemsPerPage, setitemsPerPage] = useState<number>(7);
  const [viewType, setViewType] = useState<string>("list");
  const [responseReceived, setResponseReceived] = useState<boolean>(false);
  const [isFilterPopoverOpen, setFilterPopover] = useState<boolean>(false);
  const tableRef = useRef<HTMLDivElement>(null);
  const gridRef = useRef<HTMLDivElement>(null);
  const store = useSelector((store: any) => store);
  const fileStore = useSelector((store: any) => store?.file);
  const dispatch = useDispatch();
  const _otherData = bindActionCreators(otherDataAC, dispatch);
  const isMobile = store?.otherData?.isMobile || false;

  useEffect(() => {
    let componentMounted = true;
    if (componentMounted) {
      getUploadedFiles();
      setAllTransactions();
      createReferedByEntry();
      setViewType(store?.["otherData"]?.["viewType"] || "list");
      // console.clear();
    }
    return () => {
      componentMounted = false;
    };
  }, []);



  useEffect(() => {
    let componentMounted = true;

    if (componentMounted) {
      if (viewType === "list" && tableRef)
        setitemsPerPage(getItemsPerPage(tableRef, 70));
      if (viewType === "grid" && gridRef)
        setitemsPerPage(getGridItemsPerPage(gridRef, 170));
      _otherData.setOtherData({ viewType: viewType });
    }

    return () => {
      componentMounted = false;
    };
  }, [viewType]);

  useEffect(() => {
    let componentMounted = true;

    if (componentMounted) {
      setOrignalItems(fileStore?.["filesArr"] || []);
      setFilteredItems(fileStore?.["filesArr"] || []);
      setResponseReceived(true);
    }

    return () => {
      componentMounted = false;
    };
  }, [fileStore]);

  function viewFile(data:any) {
    History.navigate(`viewFile/${data?.cid}`, { state: data });
  }

  const applyFilter = (e:any) => {
    switch (e?.target?.value) {
      case "All":
        setFilteredItems(orignalItems);
        break;
      case "Public":
        setFilteredItems(
          orignalItems.filter((item:any) => item?.encryption === false)
        );

         getActivePlanList();
        break;
      case "Encrypted":
        setFilteredItems(
          orignalItems.filter((item:any) => item?.encryption === true)
        );
        break;

      default:
        break;
    }
  };

  const handleClick = (e:any, item:any) => {
    switch (e.detail) {
      case 1:
        setInfoBarData(item);
        break;

      default:
        viewFile(item);
        break;
    }
  };

  return (
    <>
      <div className="mySpace">
        <p className="mySpace__title">Home</p>

        <div className="mySpace__searchBoxContainer">
          <div className="searchBar">
            <Searchbar
              orignalItems={orignalItems}
              setCurrentItems={setFilteredItems}
              placeholder={"Search Name / CID"}
              primaryConditionKey={"cid"}
              secondaryConditionKey={"fileName"}
            />
          </div>

          <div className="filterContainer">
            <div style={{ top: "15px", left: "-55px" }}>
              <Popover
                isOpen={isFilterPopoverOpen}
                positions={["bottom"]}
                containerClassName="filterPopoverContainer"
                onClickOutside={() => setFilterPopover(false)}
                content={
                  <div
                    className="FilterPopover"
                    onChange={(e) => {
                      applyFilter(e);
                    }}
                  >
                    <p className="FilterPopover__title">Type:</p>
                    <div className="FilterPopover__filterContainer">
                      <p>All</p>
                      <input type="radio" name="type" value={"All"} />
                    </div>
                    <div className="FilterPopover__filterContainer">
                      <p>Encrypted</p>
                      <input type="radio" name="type" value={"Encrypted"} />
                    </div>
                    <div className="FilterPopover__filterContainer">
                      <p>Public</p>
                      <input type="radio" name="type" value={"Public"} />
                    </div>
                  </div>
                }
              >
                <button
                  className="outlineBtn"
                  onClick={() => {
                    setFilterPopover(true);
                  }}
                >
                  Filter
                </button>
              </Popover>
            </div>

            <div className="filterContainer__viewTypeButton">
              <div
                className={viewType === "list" ? "viewType active" : "viewType"}
                onClick={() => {
                  setViewType("list");
                }}
              >
                <TfiViewListAlt />
              </div>
              <div
                className={viewType === "grid" ? "viewType active" : "viewType"}
                onClick={() => {
                  setViewType("grid");
                }}
              >
                <TfiLayoutGrid2 />
              </div>
            </div>
          </div>
        </div>

        {viewType === "list" ? (
          <div className="mySpace__tableContainer" ref={tableRef}>
            <table>
              <thead>
                <tr className="tableHead">
                  <th>Name</th>
                  {!isMobile ? (
                    <>
                      <th>CID</th>
                      <th>Size</th>
                      <th>File Type</th>
                      <th>Last Modified</th>
                    </>
                  ) : (
                    <></>
                  )}
                </tr>
              </thead>
              <tbody>
                {responseReceived ? (
                  currentItems?.length > 0 &&
                  currentItems.map((item, i) => (
                    <tr
                      key={i}
                      className={
                        infoBarData?.id === item?.id ? "active" : "ptr"
                      }
                      onClick={(e) => {
                        handleClick(e, item);
                      }}
                    >
                      <td>
                        <span className="fileIcon">
                          {getFileIcon(
                            item?.fileName,
                            item?.encryption === "true" || item?.encryption
                              ? true
                              : false
                          )}
                        </span>
                        &nbsp;
                        <p
                          onClick={() => {
                            viewFile(item);
                          }}
                        >
                          <span className="title">
                            {clipText(item?.fileName, 20)}
                          </span>
                        </p>
                      </td>

                      {isMobile ? (
                        <></>
                      ) : (
                        <>
                          <td>
                            <span className="cid">{item?.cid}</span>
                            &nbsp;
                            <span
                              className="icon"
                              onClick={() => {
                                copyToClipboard(item.cid);
                              }}
                            >
                              <MdOutlineContentCopy />
                            </span>
                          </td>

                          <td>{bytesToString(item?.fileSizeInBytes)}</td>
                          <td>{item?.encryption ? "Encrypted" : "Public"}</td>
                          <td>
                            {moment(item?.createdAt).format("DD-MM-YYYY")}
                          </td>
                        </>
                      )}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td>
                      <p style={{ width: "100%" }}>
                        <Skeleton />
                      </p>
                    </td>
                    {isMobile ? (
                      <></>
                    ) : (
                      <>
                        <td>
                          <span style={{ flex: "0.95" }}>
                            <Skeleton />
                          </span>
                        </td>
                        <td>
                          <Skeleton />
                        </td>
                        <td>
                          <Skeleton />
                        </td>
                        <td>
                          <Skeleton />
                        </td>
                      </>
                    )}
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="mySpace__gridContainer" ref={gridRef}>
            {responseReceived ? (
              currentItems?.length > 0 &&
              currentItems.map((item, i) => (
                <div
                  style={{ height: "150px" }}
                  key={`card${i}`}
                  className={
                    infoBarData?.id === item?.id
                      ? "FileCard active"
                      : "FileCard"
                  }
                  onClick={(e) => {
                    handleClick(e, item);
                  }}
                >
                  <div className="FileCard__iconBox">
                    <span className="fileIcon">
                      {getFileIcon(
                        item?.fileName,
                        item?.encryption === "true" || item?.encryption
                          ? true
                          : false
                      )}
                    </span>
                  </div>
                  <div className="FileCard__fileName">
                    <p>{clipText(item?.fileName, 15)}</p>
                  </div>
                </div>
              ))
            ) : (
              <></>
            )}
          </div>
        )}

        <div className="mySpace__lowerContainer">
          <Pagination
            orignalData={filteredItems}
            setCurrentData={setCurrentItems}
            itemsPerPage={itemsPerPage}
            type="files"
          />
        </div>
      </div>
    </>
  );
}

export default Myspace;
